module.exports = __webpack_public_path__ + "img/0Q3B5909-12_H_Black_MockedUp.4e316448.jpg";